// Flag to prevent multiple logout attempts during concurrent requests
let isLoggingOut = false;

// Flag to prevent logout during login process
let isLoggingIn = false;

// Flag to coordinate concurrent refresh operations
let isRefreshing = false;

// In-memory access token to avoid persisting sensitive data
let accessToken: string | null = null;

// Shared refresh promise to coordinate between SessionProvider and axios interceptor
let refreshPromise: Promise<string | null> | null = null;

export const AuthState = {
  get isLoggingOut() {
    return isLoggingOut;
  },
  set isLoggingOut(value: boolean) {
    isLoggingOut = value;
  },
  get isLoggingIn() {
    return isLoggingIn;
  },
  set isLoggingIn(value: boolean) {
    isLoggingIn = value;
  },
  get isRefreshing() {
    return isRefreshing;
  },
  set isRefreshing(value: boolean) {
    isRefreshing = value;
  },
  get accessToken() {
    return accessToken;
  },
  set accessToken(value: string | null) {
    accessToken = value;
  },
  get refreshPromise() {
    return refreshPromise;
  },
  set refreshPromise(value: Promise<string | null> | null) {
    refreshPromise = value;
  },
};
